import { FrontendFilterTag } from "types/types";

import FilterChip from "./FilterChip";

interface Props {
  tag: FrontendFilterTag;
}

export function Tag(props: Props) {
  const { tag } = props;
  if (tag.children.length === 0) {
    return <FilterChip tag={tag} />;
  }
  return (
    <>
      <FilterChip tag={tag} />
      {tag.children.map((child) => (
        <Tag tag={child} key={child.id} />
      ))}
    </>
  );
}
